import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import { Link } from "react-router-dom";
// import { faUserAlt } from "@fortawesome/free-solid-svg-icons/faUserAlt";
import Moment from "moment";
import axios from "axios";
// import { VictoryPie } from "victory";
import { baseUrl } from "../../actions/baseUrl";
import pairicon from "../images/pair-icon.png"
// import depositicon from "../images/deposit-icon.png"
// import kyccompleteicon from "../images/kyc-complete-icon.png"
// import kycpendingicon from "../images/kyc-pending-icon.png"
import supporticon from "../images/support-icon.png"
// import transactionicon from "../images/transaction-icon.png"
// import withdrawalicon from "../images/withdrawal-icon.png"
import CanvasJSReact from "../canvasjs/canvasjs.react";
var CanvasJSChart = CanvasJSReact.CanvasJSChart;





class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // balance: 0,
      // upcomingTotal: 0,
      // pastTotal: 0,
      // liveTotal: 0,
      loginHostory: [],
      userTotal: 0,
      // pendingTotal: 0,
      // completeTotal: 0,
      // supportotal: 0,
      errors: {},
      cryptoDataTotal: '',
      // totalRegisterUser:[]
    };

    this.getData = this.getData.bind(this);
  }
  componentDidMount() {
    this.getData();
  }
  componentWillUnmount() {
    this.getData();
  }
  componentWillReceiveProps(nextProps) {
    this.getData();
  }

  getData() {
    // const { user } = this.props.auth;
    // console.log("manageusers", this.props.auth)
    axios
      .get(baseUrl + "/api/v1/totaluser")
      .then((res) => {

        this.setState({  userTotal: res.data.result });
      })
      .catch();
    axios
      .get(baseUrl + "/api/v1/totalcoins")
      .then((res) => {
        this.setState({ cryptoDataTotal: res.data.result });
      })
      .catch();
    // axios
    //   .get(baseUrl + "/api/getPenddingTotal")
    //   .then((res) => {
    //     this.setState({ pendingTotal: res.data.total });
    //   })
    //   .catch();
    // axios
    //   .get(baseUrl + "/api/getCompleteTotal")
    //   .then((res) => {
    //     this.setState({ completeTotal: res.data.total });
    //   })
    //   .catch();
    // axios
    //   .get(baseUrl + "/api/getSupportTotal")
    //   .then((res) => {
    //     this.setState({ supportotal: res.data.total });
    //   })
    //   .catch();
    // axios
    //   .get(baseUrl + "/api/crypto-data")
    //   .then((res) => {
    //     this.setState({ cryptoDataTotal: res.data.length });
    //   })
    //   .catch();
    axios
      .get(baseUrl + "/api/v1/totalpairs")
      .then((res) => {
        this.setState({ pairDataTotal: res.data.result });
      })
      .catch();
    // axios
    //   .get(baseUrl + "/api/userdepositHistory")
    //   .then((res) => {
    //     this.setState({ depositeHistoryTotal: res.data.length });
    //   })
    //   .catch();
    // axios
    //   .get(baseUrl + "/api/userwithdrawalHistory")
    //   .then((res) => {
    //     this.setState({ withdrawalHistoryTotal: res.data.length });
    //   })
    //   .catch();
      // axios
      // .get(baseUrl + "/api/total_register_user")
      // .then((res) => {
      //   console.log("total_register_user",res.data)
      //   this.setState({ totalRegisterUser: res.data });
      // })
      // .catch();
  }
  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logoutUser();
  };
  // canvasFirstHTML = () => {
  //   // var percentage = new Array();
  //   // var temp = this.state.currenciesPercentage;
  //   // if (temp == null) {
  //   //   temp = 0;
  //   // } else {
  //   //   percentage = temp.split(",");
  //   //   if (this.state.currenciesId) {
  //   const html = [];
  //   var dataPie = [
  //     { y: this.state.userTotal, name: "Total User" },
  //     { y: this.state.completeTotal, name: "Kyc Complete" },
  //     { y: this.state.pendingTotal, name: "Kyc Pending" }
  //     ];
  //   //     var currenciesId = new Array();
  //   //     var coinId = this.state.currenciesId;
  //   //     currenciesId = coinId.split(",");
  //   //     currenciesId.map(function (value, i) {
  //   //       dataPie.push({
  //   //         name: value,
  //   //         y: percentage[i],
  //   //       });
  //   //     });
  //   var options = {
  //     theme: "dark2",
  //     title: {
  //       text: "Kyc Record",
  //       horizontalAlign: "left",
  //       fontColor: "#026555",
  //       fontFamily: "Roboto",
  //       fontSize:20,
  //     },
  //     elements: {
  //       line: {
  //           tension: 0 // disables bezier curves
  //       }
	// },
      
  //     animationEnabled: true,
  //     data: [
  //       {
  //         type: "doughnut",
  //         showInLegend: true,
  //         indexLabel: "{name}: {y}",
  //         yValueFormatString: "####",
  //         dataPoints: dataPie,
  //       },
  //     ],

  //     backgroundColor: "transparent",
  //     color: "#fff",
  //   };
  //   html.push(<CanvasJSChart options={options} />);
  //   return html;



  // }

  // canvasSecondHTML = () => {
  //   const user = []
  //   const dataPai = []
  //   this.state.totalRegisterUser.map((data,i)=>{
  //     dataPai.push({
  //       x:new Date(data.registeredDate),
  //       y:data.id
  //     })
          
  //   })
  //   const options = {
  //     animationEnabled: true,
  //     exportEnabled: true,
  //     theme: "dark2", //"light1", "dark1", "dark2"
  //     title: {
  //       text: "User Registration",
  //       horizontalAlign: "left",
  //       fontColor: "#026555",
  //       fontFamily: "Roboto",
  //       fontSize:20,
  //     },
  //     axisY: {
  //       includeZero: true
  //     },
  //     toolTip: {
  //       enabled: true,
  //     },
  //     axisX: {
  //       lineThickness: 0,
  //       tickLength: 0,
  //       labelFormatter: function (e) {
  //         return "";
  //       },
  //     },
  //     axisY: {
  //       lineThickness: 0,
  //       gridThickness: 0,
  //       tickLength: 0,
  //       labelFormatter: function (e) {
  //         return "";
  //       },
  //     },

  //     exportEnabled: false,
  //     backgroundColor: "transparent",
  //     data: [{
  //       type: "splineArea", //change type to bar, line, area, pie, etc
  //       //indexLabel: "{y}", //Shows y value on all Data Points
  //       indexLabelFontColor: "#5A5757",
  //       indexLabelPlacement: "outside",
  //       dataPoints:dataPai
  //     }]
  //   }
  //   const html = [];

  //   html.push(<CanvasJSChart options={options} />);
  //   return html;



  // }
  showLoginHistoryHtml = () => {
    const html = [];
    var classThis = this;
    this.state.loginHostory.map(function (value, i) {
      html.push(
        <>
          {" "}
          <tr>
            <td>{i + 1}</td>
            <td>{value.email}</td>
            <td>{value.ip}</td>
            <td>{value.cityName}</td>
            <td>{value.region}</td>
            <td>{value.countryName}</td>
            <td>{Moment(value.date).format("lll")}</td>
          </tr>
        </>
      );
    });
    return html;
  };
  render() {
    const { user } = this.props.auth;
    return (
      <div>
        <div className="d-flex" id="wrapper">
  
          <Sidebar />
          <div id="page-content-wrapper">
            <Navbar />
            <div className="container-fluid">
              <button className="btn btn-link mt-2" id="menu-toggle">
                <FontAwesomeIcon icon={faList} />
              </button>
              <h4 className="mt-2 man_hadding">Dashboard</h4>
              <div className="row px-2">
                {this.state.cryptoDataTotal && (
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 p-sm-2">
                    <div className="card text-white d_box">
                      <Link to="/crypto_currency" className="card-body">
                        <h6>Currency</h6>
                        <h4>{this.state.cryptoDataTotal}</h4>
                        <div className="d_icon">
                          <i className="fa fa-inr" aria-hidden="true"></i>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
                {this.state.pairDataTotal && (
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 p-sm-2">
                    <div className="card text-white d_box">
                      <Link to="/pair_management" className="card-body">
                        <h6>Pair</h6>
                        <h4>{this.state.pairDataTotal}</h4>
                        <div className="d_icon">
                          <img src={pairicon} />
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
                {this.state.userTotal && (
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 p-sm-2">
                    <div className="card d_box">
                      <Link to="/users" className="card-body">
                        <h6>Total User</h6>
                        <h4>{this.state.userTotal}</h4>
                        <div className="d_icon">
                          <img src={supporticon} />
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
           
             
             


              </div>
              {/* <div className="row mt-5">
                <div className="col-md-8">
                <div className="white_box">
                  {this.canvasSecondHTML()}
                </div>
                </div>
                <div className="col-md-4">
				 <div className="white_box">
                  {this.canvasFirstHTML()}
                </div>
                </div>
              </div> */}

              {/* <div className="col-md-4 col-12">
                    <div className="payment_analist">
                      <div className="heading-outer text-center">
                        <h5 className="text-white">
                          Analysis of Payment Modes
                        </h5>
                      </div>
                      <div className="chart-outer"> */}
              {/* <canvas id="myChart"> */}
              {/* <img src="/img/successful.png"/> */}
              {/* <VictoryPie
                          animate={{
                            duration: 1000,
                          }}
                          colorScale={[
                            "#c0504e",
                            "#9bbb58",
                            "#23bfaa",
                            "#4f81bc",
                          ]}
                          data={[
                            { x: "INR", y: 135 },
                            { x:"CT", y: 160 },
                            {x:"PEX", y: 155 },
                            // { x:"",y: 25 },
                          ]}
                          style={{ labels: { fill: "white"} }}
                        /> */}
              {/* </canvas> */}
              {/* </div> */}

              {/* <div className="payment-mode">
                        <ul>
                          <li className="inr-outer">INR</li>
                          <li className="btc-outer">BTC</li>
                          <li className="eth-outer">ETH</li>
                          <li className="trx-outer">TRX</li>
                        </ul>
                      </div> */}
              {/* </div>
                  </div> */}
              {/* <div className="crypt-market-status2 mt-4 ">
                <div className="man_white_box ">
                  <h5 className="pb-3">Login History</h5>
                  <div className="table-responsive ">
                    <table className="table table  border_none table-striped mb-0">
                      <thead className="thead">
                        <tr>
                          <th>#</th>
                          <th>Email</th>
                          <th>IP</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Country</th>
                          <th>Last Login</th>
                        </tr>
                      </thead>
                      <tbody>{this.showLoginHistoryHtml()}</tbody>
                    </table>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        {/* <div >
              <p>© 2021 Gramex. All Rights Reserved</p>
            </div> */}
      </div>
    );
  }
}

Dashboard.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(Dashboard);
